import labels from 'src/labels'
import mobimedUrl from 'src/mobimed'
import customLabels from 'src/customLabels'

const state = {
  authenticated: false,
  authUser: null,
  redirectPath: null,
  redirectAfterLoginPath: null,
  activatedLabels: labels,
  mobimedUrl,
  customLabels,
  perPage: 50,
  filters: {
    stockRotationsIndex: {
      shouldUse: false,
      query: {
        dateRange: '',
        product: '',
        warehouse: '',
        cause: '',
        costCenter: '',
        accumulated: '',
        currentPage: 2,
        perPage: ''
      }
    }
  }
}

export default state
